<template>
  <div class="footer">
    <div class="pull-left">
      SSP Portal v. <span v-once>{{ version }}</span>
    </div>
    <div class="pull-right">
      <strong>SS PARISI</strong> Todos os direitos reservados &copy; <span v-once>{{ year }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      version: VERSION
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/PageFooter.vue